import { render, staticRenderFns } from "./indexMensajeria.vue?vue&type=template&id=3be2eaf9"
import script from "./indexMensajeria.vue?vue&type=script&lang=js"
export * from "./indexMensajeria.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports